import React from 'react'
import { PowerBIEmbed } from 'powerbi-client-react'
import { models, Report, Embed, IEmbedConfiguration } from 'powerbi-client'
import httpClient from '../../../httpClient'
import './Dashboard.scss'

interface Props {
  layoutMobile: boolean
  reportId: string
}

const Dashboard: React.FC<Props> = (props) => {
  const layoutType = props.layoutMobile
    ? models.LayoutType.MobilePortrait
    : models.LayoutType.Master

  const [report, setReport] = React.useState<Report>()

  const [reportEmbedConfig, setreportEmbedConfig] =
    React.useState<IEmbedConfiguration>({
      type: 'report',
      embedUrl: undefined,
      accessToken: undefined,
      tokenType: models.TokenType.Embed, // = 1
      pageName: undefined,
      settings: {
        layoutType: layoutType,
        filterPaneEnabled: false,
        navContentPaneEnabled: false,
        localeSettings: {
          language: 'se',
          formatLocale: 'sv-SE'
        }
      }
    })

  const getReportConfig = async () => {
    const url = 'ExternalEmbedTokenApi'
    const response = await httpClient.post(
      url,
      { reportName: props.reportId },
      ''
    )

    setreportEmbedConfig({
      ...reportEmbedConfig,
      embedUrl: response.embedUrl,
      accessToken: response.accessToken
    })
  }

  React.useEffect(() => {
    getReportConfig()
  }, [props.reportId])

  try {
    return (
      <PowerBIEmbed
        embedConfig={reportEmbedConfig}
        cssClassName={'report-style-class'}
        getEmbeddedComponent={(embedObject: Embed) => {
          setReport(embedObject as Report)
        }}
      />
    )
  } catch (e) {
    console.error(e)
    return null
  }
}

export default Dashboard
